import React, { useState } from 'react';
import { Settings } from 'lucide-react';
import { Button } from 'src/shared/components/ui/button';
import useCanAdministerOrganisations from 'src/app/admin/hooks/useCanAdministerOrganisations';
import ManageOrganisationSheet from 'src/app/admin/components/manage-organisation-sheet/ManageOrganisationSheet';
import CustomerDetails from 'src/app/admin/views/user-management/components/customer-details/CustomerDetails';

type OrganisationLozengeProps = {
    customerId: string;
    customerName: string;
};

/**
 * Names the organisation an admin page is about, and — for whoever may change it — offers the
 * edit right there, since that is where the reader is already looking.
 */
const OrganisationLozenge = ({ customerId, customerName }: OrganisationLozengeProps) => {
    const { canManage, canDelete } = useCanAdministerOrganisations();
    const [isEditing, setIsEditing] = useState(false);

    // Without the edit there is nothing to open the sheet, so it is not rendered either.
    // The sheet behind the gear offers both, so either right is reason enough to open it.
    if (!canManage && !canDelete) {
        return <CustomerDetails customerName={customerName} />;
    }

    return (
        <>
            <CustomerDetails
                customerName={customerName}
                action={
                    <Button
                        variant='ghost'
                        size='icon'
                        aria-label='Edit organisation'
                        data-testid='org-page-edit-organisation'
                        onClick={() => setIsEditing(true)}
                    >
                        <Settings />
                    </Button>
                }
            />
            <ManageOrganisationSheet open={isEditing} onOpenChange={setIsEditing} customerId={customerId} customerName={customerName} />
        </>
    );
};

export default OrganisationLozenge;
